
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const CtaSection: React.FC = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="container mx-auto max-w-6xl">
        <div className="bg-gradient-to-r from-primary/10 to-secondary/20 rounded-2xl p-10 md:p-16 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to boost your productivity?
          </h2>
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            Join thousands of product builders who use PromptHub to craft better AI outputs.
          </p>
          <Button asChild size="lg" className="rounded-full px-8">
            <Link to="/sign-up">Get Started — It's Free</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
